import Script from 'next/script'
import { getAppConfig } from '@/config/config'

const publicRuntimeConfig = getAppConfig()
const basePath = publicRuntimeConfig.basePath

export default function Config() {
  return (
    <Script
      src={`${basePath}/publicRuntimeConfig.js`}
      strategy="beforeInteractive"
      onLoad={() => console.log('[Config] loaded configuration script')}
      onError={(error) => console.error('[Config] Error while loading configuration script', error)}
    />
  )
}
